import React from 'react';
import { Navigate } from 'react-router-dom';
import LoaderScreen from './loader/loaderScreen';
import { useSelector } from 'react-redux';

const ProtectedRoute = ({ isAuthenticated, children }) => {
  const { profileLoader } = useSelector((state) => state.profile);

  if (!isAuthenticated) {
    // Redirect to login if not authenticated
    return <Navigate to="/auth/admin_login" replace />;
  }

  return (
    <>
      <div class="page-content lg:ml-[280px]">
        <div class="container-xxl">
          {profileLoader ? <LoaderScreen /> : <>{children}</>}
        </div>
      </div>
    </>
  );
};

export default ProtectedRoute;
